import { render, staticRenderFns } from "./product-grid-item.vue?vue&type=template&id=b2832986&"
import script from "./product-grid-item.vue?vue&type=script&lang=js&"
export * from "./product-grid-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports